<p>billing-rule works!</p>
